exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1zxB25ejdgdwouymUS1L2M {\n}\n", ""]);

// exports
exports.locals = {
	"formattedDate": "_1zxB25ejdgdwouymUS1L2M"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/FormattedDate/FormattedDate.css
// module id = 8929
// module chunks = 23